<template>
  <div class="container float-container">
    <div class="autoselect-options-container">
      <div
        v-if="showDropdown"
        class="autoselect-options"
        :style="{ zIndex: zIndex }"
      >
        <div v-for="option in filteredOptions" :key="optionKey(option)">
          <span
            :data-obfuscate="quantumObfuscate"
            class="autoselect__option"
            @click="onOptionClick(option.value)"
            :title="titleFn(option)"
          >
            <!-- Slot de render: si no lo usan, cae en el default -->
            <slot name="option" :option="option">
              {{ defaultLabel(option) }}
            </slot>
          </span>
        </div>
      </div>

      <img
        class="caret"
        v-if="showCaret"
        :src="caret"
        @click="toggleDropdown"
        alt="Sucursal"
      />
    </div>

    <text-input
      ref="textInput"
      class="text-input"
      :hint="hint"
      :label="label"
      :name="name"
      :value="selectedValue"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
      :reportGTMBlur="false"
      :scroll-on-focus="scrollOnFocus"
      @input="onInput"
      @onFocus="onFocus"
      @onBlur="onBlur"
      @click="$emit('click')"
      :analyticsName="analyticsName"
      :analyticsTypology="analyticsTypology"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";

export default {
  name: "BranchOfficeSelect",
  components: { TextInput },
  props: {
    // TextInput props relevantes
    hint: String,
    label: String,
    name: String,
    required: Boolean,
    subhint: String,
    validationError: String,
    scrollOnFocus: Boolean,
    analyticsName: String,
    analyticsTypology: String,
    quantumObfuscate: [Boolean, String],

    // v-model externo
    value: [String, Number],

    // Opciones ya mapeadas {label,value,provincia,localidad,direccion,distancia?}
    options: {
      type: Array,
      default: () => []
    },

    // Personalización
    zIndex: {
      type: Number,
      default: 11 // el segundo usaba 11; el primero 1. Podés sobreescribir.
    },
    titleFn: {
      type: Function,
      default: o => `${o.value} - ${o.direccion} - ${o.localidad}`
    },
    displayFn: {
      type: Function,
      default: o => `${o.value} - ${o.direccion} - ${o.localidad}`
    }
  },
  data() {
    return {
      focused: false,
      internalValue: this.value,
      forceShowDropdown: false,
      caret: require("@/assets/img/1x/arrow-simple-down.svg")
    };
  },
  computed: {
    showDropdown() {
      return (
        this.forceShowDropdown ||
        (this.focused && this.filteredOptions.length !== this.options.length)
      );
    },
    showCaret() {
      return !this.internalValue;
    },
    filteredOptions() {
      const inputValue =
        this.internalValue && this.internalValue !== "undefined"
          ? String(this.internalValue).trim()
          : "";

      if (!inputValue) return this.options;

      const needle = inputValue.toLowerCase();
      return this.options.filter(item => {
        const haystack =
          (item.value || "").toString().toLowerCase() +
          (item.label || "").toString().toLowerCase() +
          (item.provincia || "").toString().toLowerCase() +
          (item.direccion || "").toString().toLowerCase() +
          (item.localidad || "").toString().toLowerCase();
        return haystack.indexOf(needle) !== -1;
      });
    },
    selectedValue() {
      if (!this.focused) {
        const option = this.options.find(
          val => val.value === this.internalValue
        );
        return option && option.label ? this.displayFn(option) : "";
      } else {
        return this.internalValue;
      }
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  },
  methods: {
    optionKey(option) {
      return `${option.value} - ${option.direccion} * ${option.localidad}`;
    },
    defaultLabel(o) {
      // Igual al comportamiento "Old"
      return this.displayFn(o);
    },
    onInput(val) {
      this.internalValue = val;
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      setTimeout(() => {
        this.focused = false;
        this.internalValue = this.selectedValue ? this.internalValue : "";
        this.$emit("input", this.selectedValue ? this.internalValue : "");
      }, 230);
    },
    onOptionClick(val) {
      this.$emit("input", val);
      this.internalValue = val;
      this.forceShowDropdown = false;
    },
    toggleDropdown() {
      this.forceShowDropdown = !this.forceShowDropdown;
      if (
        this.forceShowDropdown &&
        this.$refs.textInput &&
        this.$refs.textInput._focus
      ) {
        this.$refs.textInput._focus();
      }
    }
  }
};
</script>

<style scoped>
.autoselect-options-container {
  position: relative;
}
.autoselect-options-container .caret {
  position: absolute;
  right: 0;
  top: 0;
  border-right: 16px solid transparent;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  cursor: pointer;
  z-index: 10;
}
.autoselect-options {
  position: absolute;
  left: 0;
  right: 0;
  top: 56px;
  background: white;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
}
.autoselect__option {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0;
  border-bottom: 1px solid #bdbdbd;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  cursor: pointer;
}
.autoselect-options div {
  padding: 0 16px;
}
.autoselect-options div:hover {
  background-color: #eeeeee;
}
.autoselect-options div:last-child span {
  border-bottom: 0;
}
.autoselect-options span:hover {
  color: #000;
}
</style>
